// import the required animation functions from the angular animations module
import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideToggleAnimation =
  // trigger name for attaching this animation to an element using the [@triggerName] syntax
  trigger('slideToggle', [
    state(
      'expanded',
      style({
        height: '*'
      })
    ),
    state(
      'collapsed',
      style({
        height: 0,
        overflow: 'hidden'
      })
    ),
    transition('expanded <=> collapsed', animate('300ms ease-in-out'))
  ]);
